import React, { useState } from 'react';

function CollapsibleFAQ({ faqs }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleCollapsibleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 id="faq" className="highlighted">
        FAQ
      </h1>
      <div className="questions-container">
        {faqs.map((faq, index) => (
          <div className="question" key={index}>
            <button
              className={`collapsible ${activeIndex === index ? 'active' : ''}`}
              onClick={() => handleCollapsibleClick(index)}
            >
              {faq.question}
            </button>
            {activeIndex === index && (
              <div className="content">
                <p>{faq.answer_paragraph}</p>
                {faq.answer_list.length > 0 && (
                  <ul>
                    {faq.answer_list.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CollapsibleFAQ;
